import React, { useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "./api";

export default function PlaidConnect() {
  const { getToken } = useAuth();
  const [linkToken, setLinkToken] = useState(null);

  useEffect(() => {
    async function fetchLinkToken() {
      try {
        const api = createApiClient(getToken);
        const res = await api.post("/api/plaid/create_link_token");
        setLinkToken(res.data.link_token);
      } catch (err) {
        console.error("Failed to fetch link token", err);
      }
    }

    fetchLinkToken();
  }, [getToken]);

  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: async (public_token) => {
      try {
        const api = createApiClient(getToken);
        await api.post("/api/plaid/exchange_token", { public_token });

        // 🔥 THIS IS THE MISSING STEP
        await api.post("/api/transactions/sync");

        console.log("Public token exchanged and transactions synced");

      } catch (err) {
        console.error("Token exchange failed", err);
      }
    },
  });

  return (
    <button
      onClick={() => open()}
      disabled={!ready}
      className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
    >
      {linkToken ? "Connect Bank" : "Loading…"}
    </button>
  );
}
